import type { NotificationQueryParams } from '@/types'

export const notificationsQueryKeys = {
  all: ['notifications'] as const,
  lists: ['notifications', 'list'] as const,
  list: (params: NotificationQueryParams | undefined) =>
    ['notifications', 'list', params] as const,
  infiniteList: (params: Omit<NotificationQueryParams, 'page'> | undefined) =>
    ['notifications', 'infiniteList', params] as const,
  infiniteLists: ['notifications', 'infiniteList'] as const,
  unreadCount: ['notifications', 'unreadCount'] as const,
  companyFacets: ['notifications', 'companyFacets'] as const,
  templates: ['notifications', 'templates'] as const,
  template: (id: string) => ['notifications', 'template', id] as const,
}
